import { environment } from "../config/environment";
import { getFromBackendAPI } from "./api.service";

export interface ClientDto {
  id: string;
  name: string;
  irdNumber?: string;
  accountantEmail?: string;
  managerEmail?: string;
  partnerEmail?: string;
  office?: string;
}

export async function searchClients(
  search?: string,
  limit: number = 50
): Promise<ClientDto[]> {
  const params = new URLSearchParams();
  if (search) params.set("search", search);
  if (limit) params.set("limit", limit.toString());
  const query = params.toString();
  const endpoint = `${environment.api.baseUrl}${environment.api.endpoints.clients}${query ? `?${query}` : ""}`;
  return await getFromBackendAPI<ClientDto[]>(endpoint);
}
